import { Button, Typography } from 'mobily-ui-library/lib';
import Modal from '../Modal/Modal';
import './InstallationRegModal.scss';
import { useTranslation } from 'react-i18next';

interface Props {
    id?: string;
    rtl?: boolean;
    modalFirstButtonClick?: () => void;
    handleHeaderCancel?: () => void;
}

function InstallationRegModal({ rtl, id, modalFirstButtonClick, handleHeaderCancel }: Props) {
    const { t } = useTranslation();

    return (
        <Modal className={'InstallationReg__Modal'} handleHeaderCancel={handleHeaderCancel} id={id} rtl={rtl}>
            <Typography rtl={rtl} className='CC__MST CCM__title mb-0 lh-sm'>{t('Your_selected_location_is_not_yet_covered_by_Mobily')} </Typography>
            <Typography rtl={rtl} className='CC__MST CCM__title mb-5 lh-sm'>{t('Please_submit_a_request_to_get_started')}</Typography>
            {/* <Typography rtl={rtl} className='CC__MST mb-1 lh-sm mb-5'>{t('Click_on_the_link_for_more_information_here')}</Typography> */}
            <Button rtl={rtl} className='CC__MButton' onClick={modalFirstButtonClick}>{t('CONTINUE_WITH_REQUEST')}</Button>
        </Modal>
    )
}

export default InstallationRegModal